
<b-container id="app" fluid class="d-flex w-100">
  <b-row :class="{ 'h-100': !mixinEnvironnement_inEditor }">
    <div class="w-100 d-flex flex-column">
      <header>
        <BandeauNavigateurNonSupporte v-if="!mixinEnvironnement_isNavigateurSupporte" />
        <Navigation />
      </header>
      <div
        v-if="mixinEnvironnement_isNavigateurSupporte && $route.fullPath.indexOf('casino') > -1"
        class="app_contenu"
        :class="{ 'h-100': !mixinEnvironnement_inEditor }"
      >
        <keep-alive>
          <router-view :key="$route.path + $route.query"></router-view>
        </keep-alive>
      </div>
      <div
        v-else-if="
          mixinEnvironnement_isNavigateurSupporte && $route.fullPath.indexOf('casino') == -1
        "
        class="app_contenu"
        :class="{ 'h-100': !mixinEnvironnement_inEditor }"
      >
        <router-view :key="$route.path + $route.query"></router-view>
      </div>
    </div>
  </b-row>
</b-container>
